import React, { memo } from "react";
import Tooltip from "@mui/material/Tooltip";
import { FileTypes, MediaFileType, MediaType } from '../../../models/media.models';
import ImageComponent from '../media/image.component';
import { MediaModel } from '../../../models/templates.models';
import { PdfLargeIcon, ZipLargeIcon, WordLargeIcon, DocIcon, XlsLargeIcon, TxtIcon, VideoIcon, MusicIcon, ImgLargeMediaIcon } from '../../../icon';

interface Props {
    media?: MediaModel[];
}

const MediaItem = (media: MediaModel) => {
    let iconOrImage: React.ReactNode;
    switch (media.ContentType) {
        case MediaType.IMAGE:
        case MediaType.IMAGE_GIF:
        case MediaType.IMAGE_JPEG:
        case MediaType.IMAGE_ARW:
        case MediaType.IMAGE_PNG:
        case MediaType.IMAGE_WEBP:
        case MediaType.IMAGE_SVG:
            iconOrImage = <ImgLargeMediaIcon className="w-4 h-4" />;
            break;
        case MediaFileType.PDF:
        case FileTypes.PDF_TYPE:
            iconOrImage = <PdfLargeIcon className="w-4 h-4" />;
            break;
        case MediaFileType.ZIP:
        case FileTypes.ZIP_TYPE:
            iconOrImage = <ZipLargeIcon className="w-4 h-4" />;
            break;
        case MediaFileType.DOC:
        case FileTypes.WORD_TYPE:
            iconOrImage = <WordLargeIcon className="w-4 h-4" />;
            break;
        case MediaFileType.DOCX:
            iconOrImage = <DocIcon className="w-4 h-4" />;
            break;
        case MediaFileType.XLSX:
        case FileTypes.XLSX_TYPE:
            iconOrImage = <XlsLargeIcon className="w-4 h-4" />;
            break;
        case MediaFileType.TXT:
        case FileTypes.TEXT_TYPE:
            iconOrImage = <TxtIcon className="w-4 h-4" />;
            break;
        case MediaType.VIDEO:
        case MediaType.VIDEO_MP4:
            iconOrImage = <VideoIcon className="w-4 h-4" />;
            break;
        case MediaType.AUDIO:
        case MediaType.AUDIO_MP3:
        case MediaType.AUDIO_MPeg:
            iconOrImage = <MusicIcon className="w-4 h-4" />;
            break;
        default:
            iconOrImage = <DocIcon className="w-4 h-4" />;
    }
    return iconOrImage
};

export const MediaRenderer = (props: Props) => {
    return (
        <div className="d-flex align-center ">
            {!props.media?.length ? <div className="align-center">--</div> :
                <div className="d-flex">
                    {props.media.map((mediaItem, idx) => mediaItem ? <Tooltip title={mediaItem.ContentType?.includes("image") ? <> <ImageComponent MediaUrl={mediaItem.Url} classname="w-8 h-8 p-2" text={true} /></> : mediaItem.Name} placement="top" arrow>
                        <div className="d-flex align-center" >
                            {MediaItem(mediaItem)}
                        </div>
                    </Tooltip> : null)
                    }
                </div >
            }
        </div >
    );
};
